import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;
    gap: 12px;
`;

export const IconContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
`;

export const Message = styled.p`
    font-size: 14px;
    color: ${({ theme }) => theme.colors.interfaceGray500 || '#6B7280'};
    margin: 0;
`;




